import React from 'react';
import './PowerUpSwitch.css';

const PowerUpSwitch = ({
  active,
  ariaProps,
  customClassname,
  label,
  onClick,
  switchBallColor = '#fff',
  switchRef,
}) => {
  function handleButtonClick() {
    onClick();
  }

  function renderClassName() {
    if (active) {
      return 'PowerUp-Switch-active-container';
    }

    return 'PowerUp-Switch-inactive-container';
  }

  function renderBallPositionClassName() {
    if (active) {
      return 'PowerUp-Switch-position-active';
    }

    return 'PowerUp-Switch-position-inactive';
  }

  return (
    <div className="PowerUp-Switch-container">
      <button
        ref={switchRef}
        className={`PowerUp-Switch-button-container ${renderClassName()}
        ${customClassname}`}
        onClick={handleButtonClick}
        type="button"
        {...ariaProps}
      >
        <div
          className={`PowerUp-Switch-ball ${renderBallPositionClassName()}`}
          style={{ backgroundColor: switchBallColor }}
        />
      </button>

      <span className="PowerUp-Switch-label">{label}</span>
    </div>
  );
};

export default PowerUpSwitch;
